import { render, staticRenderFns } from "./ContactTypeFilter.vue?vue&type=template&id=20ec324c&scoped=true&"
import script from "./ContactTypeFilter.vue?vue&type=script&lang=js&"
export * from "./ContactTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec324c",
  null
  
)

export default component.exports